import { render, staticRenderFns } from "./CategoryConfig.vue?vue&type=template&id=66324eca&"
import script from "./CategoryConfig.vue?vue&type=script&lang=js&"
export * from "./CategoryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports